import glaciers from '../data/glaciers.json';

const getMountain = (id) => {
  if (!id) return { name: 'Unknown' };  // Return a default object instead of null
  const glacier = glaciers.find(glacier => glacier.id === id);
  return glacier || { name: 'Unknown' }; // Return a default object if no glacier found
};

const searchMountainByName = (searchTerm) => {
  if (!searchTerm) return [];
  return glaciers.filter(glacier =>
    glacier?.name?.toLowerCase().includes(searchTerm.toLowerCase())
  );
};

const getFavoriteMountains = () => {
  return glaciers.filter(glacier => glacier?.favorit === true);
};

export { getMountain, getFavoriteMountains, searchMountainByName };
